import chevronDown from "../assets/img/chevron-down.svg";
import { ChevronRight } from "../utils/svg";
import { useEffect, useRef } from "react";
import { NavLink, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import UpgradeModal from "./upgrade/upgrade-modal";
import { useState } from "react";
import { hideLoader, showLoader } from "./loader";
import Accounts from "../pages/accounts";
import analize from "../assets/img/products/Analytics.svg"
import { apiUrl, pageUrl, protocol } from "../utils/url";
import { audiencePosts as mangageSubscriptionPost } from "../services/postRequests/audience";
import copyIcon from "../assets/img/products/linkdarkimg.svg";
import { toast } from "react-toastify";
import ShareIcon from '../assets/img/page/share.svg'
import chainIcon from "../assets/img/products/product-pageicon.svg";
import FeedbackModal from "./feedback-modal";
import $ from 'jquery';
const PageHeader = ({ from,activePage, sidebarOpen,setSideBarOpen,plan, monetizationRef, monetizationMobileRef, communityRef, communityMobileRef, selectedProfile, projects, isPro }) => {
    const dispatch = useDispatch()
    const history = useHistory()
    const { basePath, slug } = useSelector(state => state?.slugReducer);
    const pro = from == "dashboard" ? isPro : useSelector(state => state?.proReducer);
    const planType = (from == "dashboard" || from?.includes('account')) ? plan : useSelector(state => state?.plantypeReducer);
    const newUser = useSelector(state => state?.newUserReducer);
    const [showUpgradeModal, setshowUpgradeModal] = useState(false);
    const [showFeedbackModal, setShowFeedbackModal] = useState(false);
    const accountsModalOpen = useSelector(state => state.accountsModalReducer)
    const handleShareClick = async () => {
        if (navigator.share) {
          navigator.share({
            url: `https://zaap.bio/${localStorage?.slug}`
          })
          .then(() => console.log('Successful share'))
          .catch((error) => console.log('Error sharing:', error));
        } else {
          console.log('Share API not supported');
        }
      };
    useEffect(() => {
        var headerDropdown = document.querySelector('#header-dropdown');
        headerDropdown.onclick = () => headerDropdown.classList.toggle('active');
    }, []);

    useEffect(() => {
        if (pro == undefined) showLoader()
        else hideLoader()
    }, [pro])

    const openUpgradeModal = (e) => {
        e.preventDefault();
        setshowUpgradeModal(true)
    }

    const openAccountsModal = (e) => {
        e.preventDefault();
        history.push('/account/settings')
    }
    const mangageSubscription = (e) => {
        e.preventDefault();
        showLoader()
        const myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`)
        const formdata = new FormData()
        formdata.append("project", slug ? slug : localStorage?.getItem("slug"));

        const api = apiUrl + `/manage-subscription`;
        const setOptions = {
            method: "POST",
            body: formdata,
            headers: myHeaders
        }
        mangageSubscriptionPost(api, hideLoader, setOptions).then((response) => {
            if (response) {
                location.href = response?.url
                showLoader()
            }
        })

    }

    const eventTrack = (event) => {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`)
        const formdata = new FormData()
        // formdata.append("project", slug ? slug : localStorage?.getItem("slug"));
        formdata.append("name", "Click on pro button");

        const api = apiUrl + `/event-track`;
        const setOptions = {
            method: "POST",
            body: formdata,
            headers: myHeaders,
        }
        mangageSubscriptionPost(api, hideLoader, setOptions).then((response) => {
            if (response) {
                location.href = response?.url
                showLoader()
            }
        })
        history.push(`/project/${localStorage?.slug}/settings`)

    // if (newUser == 1) {
        // history.push(`/project/${localStorage?.slug}/settings/upgrade-zaap`)
    // }else{
    //     openUpgradeModal(event)
    // }
    }
    function handlemove() {
        
        if (localStorage?.getItem("slug")) {
            history.push({
                pathname: `/project/${localStorage.slug}/settings/team-members`,
            })
        }
        else if (projects) {
            projects.map((val) => {
                if (val?.id === selectedProfile) {
                    history.push(`/project/${localStorage.slug}/settings/team-members`)
                }
            })
        }
    }
    function upgrade_page() {
        history.push(`/project/${localStorage?.slug}/settings/upgrade-zaap`)
    }
    function settingsURL() {
        if(window.location.pathname.includes("settings")){
            history.goBack();
        }else{
        if (localStorage?.getItem("slug")) {
            history.push(`/project/${localStorage.slug}/settings`);
        }
        else if (projects) {
            projects.map((val) => {
                if (val?.id === selectedProfile) {
                    history.push(`/project/${localStorage.slug}/settings`);
                }
            })
        }
        }
    }
    function settingsTeam() {
        
        if (localStorage?.getItem("slug")) {
            history.push({
                pathname:`/project/${localStorage.slug}/settings`,
                state: { fromHeaderPage: 'team' }}
            );
        }
        else if (projects) {
            projects.map((val) => {
                if (val?.id === selectedProfile) {
                    history.push({
                        pathname:`/project/${val?.slug}/settings`,
                        state: { fromHeaderPage: 'team' }}
                    );
                }
            })
        }
    }

    const copyingText = () => {
        navigator.clipboard
          .writeText(`https://zaap.bio/${slug}`)
          .then((r) => toast.success("Successfully Copied"));
      };
      const toggleSidebar = () => {
        if (from == "settingsMobile" || from == 'accountMobile') {
            if(sidebarOpen){
                    localStorage.removeItem('activePage');
                    history.push(`/project/${localStorage.slug}/campaigns`)
            }else{
                setSideBarOpen(!sidebarOpen);
            }
        }else{
            localStorage.removeItem('activePage');
            history.push(`/project/${localStorage.slug}/campaigns`);
            // history.push(`project/${slug}/campaigns`);
        }
      };
      const handleDropdownHide = () => {
        var iframe = document.getElementById('hubspot-conversations-iframe');
        if(iframe){
            iframe.style.setProperty('display', 'none', 'important');
        }
      };
    $(document).on('click',function(e){
        const dropdownMenu = document.querySelector('.help-dropdown-menu')?.classList;
        if(!dropdownMenu?.contains('show')){
            handleDropdownHide()
        } else {
            e.stopPropagation();
        }
    })

    const openHubSpotChat = (e) => {
        e.stopPropagation();
        if(!document.getElementById('hubspot-conversations-iframe')){
            showLoader();
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.id = 'hs-script-loader';
            script.async = true;
            script.defer = true;
            script.src = '//js-na1.hs-scripts.com/46190671.js';
            document.body.appendChild(script);
            script.onload = () => {
                const checkWidgetInterval = setInterval(() => {
                    if (window?.HubSpotConversations) {
                        clearInterval(checkWidgetInterval);
                        // window.HubSpotConversations.resetAndReloadWidget();
                        window.HubSpotConversations.widget?.open();
                        window?.HubSpotConversations?.on('widgetClosed', handleDropdownHide);
                        if(document.getElementById('hubspot-conversations-iframe')){
                            hideLoader();
                        }
                    }
                }, 500);
            };
        }else {
            if (window?.HubSpotConversations) {
                var iframe = document.getElementById('hubspot-conversations-iframe')
                window.HubSpotConversations.widget?.open();
                iframe.style.setProperty('display', 'initial', 'important');
            }
        }
    };
    return (
        <>
            <header className="d-flex align-items-center justify-content-between">
                <div className="header-dropdown-main">
                {from == "settings" || from == 'account' || from == "settingsMobile" || from == 'accountMobile'?
                    <div className="header-dropdown me-2" id="header-dropdown" onClick={toggleSidebar} style={{boxShadow:"0px 4px 8px rgba(0, 0, 0, 0.12)"}}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="9" viewBox="0 0 6 9" fill="none">
                        <path d="M5.66087 8.68483C5.2087 9.10506 4.47558 9.10506 4.02341 8.68483L0.33913 5.26085C-0.113042 4.84062 -0.113043 4.1593 0.339129 3.73908C0.791301 3.31886 1.52442 3.31885 1.97659 3.73908L5.66087 7.16306C6.11304 7.58329 6.11304 8.26461 5.66087 8.68483Z" fill="#999999"/>
                        <path d="M0.33913 5.26085C-0.113042 4.84062 -0.113043 4.1593 0.339129 3.73908L4.02285 0.315169C4.47502 -0.105056 5.20814 -0.105056 5.66031 0.315169C6.11248 0.735393 6.11248 1.41671 5.66031 1.83694L1.97603 5.26092C1.52385 5.68114 0.791301 5.68107 0.33913 5.26085Z" fill="#999999"/>
                        </svg>
                    </div>
                    :
                    <>
                    <div className="header-dropdown dropdown-toggle noselect me-2" id="header-dropdown" data-bs-toggle="dropdown" aria-expanded="false">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20" fill="none">
                            <path d="M6.79753 2.08163L3.29754 3.67498C2.20558 4.17209 1.5 5.29468 1.5 6.53491V10.9244C1.5 12.7326 2.93313 14.0646 4.5257 14.0493L4.67998 15.6081C2.23522 15.7132 0 13.6901 0 10.9244V6.53491C0 4.67457 1.05837 2.99068 2.69631 2.24502L6.19631 0.651672C8.45824 -0.378058 10.9271 0.687585 11.9788 2.74333H10.1314C9.303 1.87847 8.00597 1.5315 6.79753 2.08163Z" fill="#012125"/>
                            <path d="M8.07722 4.08412L5.0928 6.56578C4.16169 7.34003 3.75938 8.61439 4.06786 9.81236L5.15967 14.0523C5.43178 15.109 6.16728 15.8561 7.04569 16.1831L7.45712 17.8862C5.75436 17.6431 4.21087 16.3983 3.71079 14.4563L2.61898 10.2163C2.15625 8.41938 2.75972 6.50783 4.15638 5.34646L7.1408 2.8648C9.55784 0.854945 13.1073 1.9361 14.1606 4.868L12.4971 4.868C11.5864 3.34083 9.52648 2.87901 8.07722 4.08412Z" fill="#012125"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M16.5 8.58349C16.5 6.33231 14.2796 4.82125 12.2976 5.72357L8.79756 7.31691C7.7056 7.81402 7.00002 8.93661 7.00002 10.1768V14.5663C7.00002 16.8111 9.20881 18.3221 11.1893 17.4322L14.6893 15.8596C15.7883 15.3657 16.5 14.2393 16.5 12.9937V8.58349ZM11.6963 4.2936C14.6694 2.94013 18 5.20672 18 8.58349V12.9937C18 14.8621 16.9325 16.5518 15.284 17.2925L11.784 18.8651C8.81321 20.2 5.50003 17.9335 5.50003 14.5663V10.1768C5.50003 8.3165 6.5584 6.63261 8.19634 5.88695L11.6963 4.2936Z" fill="#012125"/>
                        </svg>
                        <img src={chevronDown} id="header-chevron-down" width="8px" height="5px" alt="" className="ms-2 arrowact" />
                    </div>
                    <ul className="dropdown-menu" style={{width:"181px",zIndex:999}}aria-labelledby="header-dropdown">
                        {/* <li><NavLink activeClassName="active" className="dropdown-item" to="/dashboard"><span className="me-5">Go to Dashboard</span><ChevronRight /></NavLink></li> */}
                        {/* <li><NavLink activeClassName="active" className="dropdown-item " to={{pathname:"/account-settings",state:{plan:planType}}} ><span className="me-3">Account Settings</span><ChevronRight /></NavLink></li> */}
                        <li><NavLink activeClassName="active" className={`dropdown-item ${from?.includes("settings") && ' active' }`} to={{pathname:"settings",state:{plan:planType}}} ><span className="me-3">Settings</span><ChevronRight /></NavLink></li>
                        {/* <li><a activeClassName="active" className="dropdown-item " href="https://www.znaplink.com/support"><span className="me-5">Help</span><ChevronRight /></a></li> */}
                        {/* <li><NavLink className="dropdown-item" to={`/manage-billings`}><span className="me-5">Manage Billing</span><ChevronRight /></NavLink></li> */}


                        {/* <li className="px-2"><div className="dropdown-divider"></div></li> */}
                        <li><NavLink to="/logout" className="dropdown-item theme-active semi-bold text-decoration-none">
                            <span className="me-5 pt-0 pb-0">Log Out</span><ChevronRight />
                        </NavLink></li>
                    </ul>
                    </>
                }
                    {from == "zaap-upgrade" &&
                        <div className="header-links d-flex justify-content-center">
                            <div style={{ display: "flex",justifyContent: "center",width:"300px" }}>
                                <div style={{ backgroundColor: `#F6F6F7`, boxShadow: "none" }} className="page-preview-link d-flex align-items-center justify-content-around link-style">
                                <div style={{ flex: 1 }}>
                                    <span className="ms-2">MY Page:</span>
                                    <a className="link-inp text-decoration-none text-dark" href={`https://zaap.bio/${slug}`}target="blank" >
                                        Zaap.bio/{slug}
                                    </a>
                                </div>
                                <img className="main-courser" src={copyIcon} width="16px" alt="" onClick={(a) => copyingText()} /> 
                                </div>
                            </div>
                            <button className="btn upgrade-main-btn ms-3" style={{paddingTop:"7px",paddingBottom:"6px"}} onClick={handleShareClick}>
                                <img src={ShareIcon} className="me-2"/>
                                Share
                            </button>
                        </div>
                    }
                </div>
                <div className="page-published cursor-pointer">
                {
                        <>
                            {/* {projects?.filter((val) => val?.id == selectedProfile).map((value, index) => ( */}
                            <>
                            <span className="text-dark page-published-slug">{localStorage.slug}</span>
                            <span className={`${planType == 'basic' ? "project-types bg-f3f3f3 text-capitalize" : "sidebar-plantype"} text-capitalize`} onClick={eventTrack}>
                                {planType !== 'basic' && <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 11 10" fill="none">
                                    <path d="M3.025 5.45L3.37801 6.15601C3.49748 6.39495 3.55721 6.51442 3.63701 6.61795C3.70783 6.70982 3.79018 6.79217 3.88205 6.86299C3.98558 6.94279 4.10505 7.00252 4.34399 7.12199L5.05 7.475L4.34399 7.82801C4.10505 7.94748 3.98558 8.00721 3.88205 8.08701C3.79018 8.15783 3.70783 8.24018 3.63701 8.33205C3.55721 8.43558 3.49748 8.55505 3.37801 8.79399L3.025 9.5L2.67199 8.79399C2.55252 8.55505 2.49279 8.43558 2.41299 8.33205C2.34217 8.24018 2.25982 8.15783 2.16795 8.08701C2.06442 8.00721 1.94495 7.94748 1.70601 7.82801L1 7.475L1.70601 7.12199C1.94495 7.00252 2.06442 6.94279 2.16795 6.86299C2.25982 6.79217 2.34217 6.70982 2.41299 6.61795C2.49279 6.51442 2.55252 6.39495 2.67199 6.15601L3.025 5.45Z" stroke="#213B7C" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M6.85 0.5L7.38038 1.87899C7.50729 2.20894 7.57074 2.37392 7.66941 2.51269C7.75686 2.63568 7.86432 2.74314 7.98731 2.83059C8.12608 2.92926 8.29106 2.99271 8.62101 3.11962L10 3.65L8.62101 4.18038C8.29106 4.30729 8.12608 4.37074 7.98731 4.46941C7.86432 4.55686 7.75686 4.66432 7.66941 4.78731C7.57074 4.92608 7.50729 5.09106 7.38038 5.42101L6.85 6.8L6.31962 5.42101C6.19271 5.09106 6.12926 4.92608 6.03059 4.78731C5.94314 4.66432 5.83568 4.55686 5.71269 4.46941C5.57392 4.37074 5.40894 4.30729 5.07899 4.18038L3.7 3.65L5.07899 3.11962C5.40894 2.99271 5.57392 2.92926 5.71269 2.83059C5.83568 2.74314 5.94314 2.63568 6.03059 2.51269C6.12926 2.37392 6.19271 2.20894 6.31962 1.87899L6.85 0.5Z" stroke="#213B7C" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                }
                                {planType == 'basic' ? 'Free' : planType?.includes('credits') ? 'Ultimate' : (planType) }
                            </span>
                            </>
                            {/* ))} */}
                        </>
                    }
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>

                    <div className={`top-header-link header-link `} id="header-help-dropdown" data-bs-toggle="dropdown" aria-expanded="false">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <path d="M5.254 5.2C5.39506 4.799 5.67349 4.46086 6.03997 4.24548C6.40645 4.0301 6.83734 3.95136 7.25631 4.02323C7.67527 4.09509 8.05529 4.31291 8.32905 4.63812C8.6028 4.96332 8.75263 5.37491 8.752 5.8C8.752 7 6.952 7.6 6.952 7.6M7 10H7.006M13 7C13 10.3137 10.3137 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7Z" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        Help
                    </div>
                    <ul className="filter-dropdown-menu help-dropdown-menu dropdown-menu" aria-labelledby="header-help-dropdown">
                        <li className="filter-dropdown-item" onClick={() => window.open('mailto:team@genpage.ai')}>Contact Support</li>
                        <li className="filter-dropdown-item" onClick={() => {setShowFeedbackModal(true)}}>Share Feedback</li>
                        <li className="filter-dropdown-item "><a className="text-decoration-none text-dark w-100 p-0" target="_blank" href="https://genpage.ai/support">Support Center</a></li>
                    </ul>
                <>
                    {activePage !== "upgrade" &&
                        <>
                        {
                            planType !== 'ultra' && planType !== 'lifetime' && (newUser == 1 || newUser == true) ?
                            <>
                                <button className="border-0 header-link upgrade-main-btn " onClick={eventTrack}>
                                    {planType != 'pro' ? "Upgrade":"Upgrade"}
                                </button>
                            </>
                            :
                            pro == 0 ?
                                <>

                                    <button className="border-0 header-link upgrade-main-btn " onClick={eventTrack}>
                                        Upgrade
                                    </button>
                                </>

                                : pro == 1 && null
                            // :
                            // pro == false ?
                            //     <>
                            //         <button className="border-0 header-link upgrade-main-btn me-3" onClick={eventTrack}>
                            //             Upgrade
                            //         </button>
                            //     </>
                            //     : null
                        }
                        </>
                    }
                </>
                {/* } */}
                </div>
            </header>
{/* new sidebar from 10/17/2023*/}
            {from == "zaap-upgrade" &&
            <div className="header-links-main d-lg-none d-md-flex justify-content-center">
                <div className="header-links">
                    <div style={{ display: "flex",justifyContent: "center", width:"300px"}}>
                        <div style={{ backgroundColor: `#F6F6F7`, boxShadow: "none" }} className="page-preview-link d-flex align-items-center justify-content-around link-style">
                        <div style={{ flex: 1 }}>
                            <span className="ms-2">MY Page:</span>
                            <a className="link-inp text-decoration-none text-dark" target="blank" >
                            Zaap.bio/{slug}
                            </a>
                        </div>
                        <img className="main-courser"  style={{ color: "red" }} src={copyIcon} width="16px" alt="" onClick={(a) => copyingText()} /> 
                        </div>
                    </div>
                    <button className="btn upgrade-main-btn ms-3" style={{paddingTop:"7px",paddingBottom:"6px"}} onClick={handleShareClick}>
                        <img src={ShareIcon} className="me-2"></img>Share
                    </button>
                </div>
            </div>
            }
            {showFeedbackModal && <FeedbackModal show={showFeedbackModal} setShow={setShowFeedbackModal}/>}
            {showUpgradeModal && <UpgradeModal isOpen={showUpgradeModal} onHide={closeUpgradeModal} />}
            {/* {accountsModalOpen && <Accounts accountsModalOpen={accountsModalOpen} />} */}
        </>
    )
};

export default PageHeader;